import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from "react";
import Field from "./Field";
import { Col } from "../utils";
import FuncWidget from "./FuncWidget";
var FieldWrapper = /*#__PURE__*/function (_PureComponent) {
  _inherits(FieldWrapper, _PureComponent);
  var _super = _createSuper(FieldWrapper);
  function FieldWrapper() {
    var _this;
    _classCallCheck(this, FieldWrapper);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.renderField = function () {
      var _this$props = _this.props,
        config = _this$props.config,
        classname = _this$props.classname,
        selectedField = _this$props.selectedField,
        selectedFieldSrc = _this$props.selectedFieldSrc,
        selectedFieldType = _this$props.selectedFieldType,
        setField = _this$props.setField,
        parentField = _this$props.parentField,
        readonly = _this$props.readonly,
        id = _this$props.id,
        groupId = _this$props.groupId;
      var supportedFieldSrcs = ["func", "field"];
      if (!supportedFieldSrcs.includes(selectedFieldSrc)) {
        return "?";
      }
      var field = selectedFieldSrc === "func" ? /*#__PURE__*/React.createElement(FuncWidget, {
        isLHS: true,
        config: config,
        value: selectedField,
        fieldSrc: selectedFieldSrc,
        fieldType: selectedFieldType,
        parentField: parentField,
        setValue: setField,
        readonly: readonly,
        id: id,
        groupId: groupId,
        key: "field-func-" + id
      }) : /*#__PURE__*/React.createElement(Field, {
        config: config,
        selectedField: selectedField,
        selectedFieldSrc: selectedFieldSrc,
        selectedFieldType: selectedFieldType,
        parentField: parentField,
        setField: setField,
        customProps: config.settings.customFieldSelectProps,
        readonly: readonly,
        id: id,
        groupId: groupId,
        key: "field-" + id
      });
      var fieldLabel = selectedFieldSrc === "func" ? config.settings.funcLabel : config.settings.fieldLabel;
      var label = config.settings.showLabels && selectedFieldSrc !== "func" && /*#__PURE__*/React.createElement("label", {
        className: "rule--label"
      }, fieldLabel);
      return /*#__PURE__*/React.createElement("div", {
        key: selectedFieldSrc,
        className: classname
      }, label, field);
    };
    _this.renderFieldSources = function () {
      var _this$props2 = _this.props,
        config = _this$props2.config,
        readonly = _this$props2.readonly,
        selectedFieldSrc = _this$props2.selectedFieldSrc,
        setFieldSrc = _this$props2.setFieldSrc,
        id = _this$props2.id;
      var settings = config.settings;
      var fieldSources = settings.fieldSources,
        valueSourcesInfo = settings.valueSourcesInfo,
        renderValueSources = settings.renderValueSources;
      var fieldSourcesOptions = fieldSources.map(function (srcKey) {
        return [srcKey, {
          label: valueSourcesInfo[srcKey].label
        }];
      });
      var ValueSources = function ValueSources(pr) {
        return renderValueSources(pr, config.ctx);
      };
      var sourceLabel = settings.showLabels ? /*#__PURE__*/React.createElement("label", {
        className: "rule--label"
      }, "\xA0") : null;
      return fieldSources.length > 1 && !readonly && /*#__PURE__*/React.createElement("div", {
        key: "fieldsrc",
        className: "rule--fieldsrc"
      }, sourceLabel, /*#__PURE__*/React.createElement(ValueSources, {
        key: "fieldsrc-" + id,
        valueSources: fieldSourcesOptions,
        valueSrc: selectedFieldSrc,
        config: config,
        setValueSrc: setFieldSrc,
        readonly: readonly,
        title: settings.fieldSourcesPopupTitle
      }));
    };
    return _this;
  }
  _createClass(FieldWrapper, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        classname = _this$props3.classname,
        canSelectFieldSource = _this$props3.canSelectFieldSource;
      var fieldSources = canSelectFieldSource && this.renderFieldSources();
      var field = this.renderField();
      if (!canSelectFieldSource) {
        return field;
      } else {
        return /*#__PURE__*/React.createElement(Col, {
          className: "rule--field-wrapper"
        }, fieldSources, field);
      }
    }
  }]);
  return FieldWrapper;
}(PureComponent);
export { FieldWrapper as default };